export default __webpack_public_path__ + "static/media/PageNotFound.6578e8d5.svg";